<div [ngClass]="{ 'mat-ng-select': !tableStyle, 'd-flex': tableStyle }">
    <div class="d-flex align-items-center person-select-row">
        <ng-select
            class="flex-fill persons-select"
            [class.ng-select-fill]="!tableStyle"
            [formControl]="fc"
            [placeholder]="field.name"
            (change)="onSelection($event)">
            @for (person of persons; track person.id) {
                <ng-option [value]="person.id">
                    <div class="d-flex justify-content-between w-100 gap-2">
                        <span>{{ person.name }}</span>
                        <small class="text-ellipsis">{{ person.phone_number | phoneNumber }}</small>
                    </div>
                </ng-option>
            }
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="p-2">
                    @if (hasCustomerSelected) {
                        <span>Geen contactpersonen gevonden</span>
                        <br />
                        <a class="add-person-link" (click)="openCreatePersonDialog(searchTerm)">
                            + Contactpersoon toevoegen
                        </a>
                    } @else {
                        <span>Selecteer eerst een opdrachtgever</span>
                    }
                </div>
            </ng-template>
        </ng-select>
        @if (fc.value && !fc.disabled) {
            <button
                (click)="openEditPersonDialog()"
                mat-icon-button
                type="button"
                tabindex="-1"
                title="Contactpersoon bewerken">
                <mat-icon>edit</mat-icon>
            </button>
        }
    </div>
    <mat-error [control]="fc"></mat-error>
    @if (selectedPersonPhoneNumber) {
        <mat-hint>
            Telefoon:
            <a [href]="'tel:' + selectedPersonPhoneNumber">
                {{ selectedPersonPhoneNumber | phoneNumber }}
            </a>
        </mat-hint>
    }
</div>
